/* Créaroma Mini-Cart B — Shopify Ajax Cart, optional enhancement, native form preserved without JavaScript */
(() => {
  function init() {
    const root=document.querySelector('[data-cr2-pdp]');
    const drawer=root?.querySelector('[data-cr2-mini-cart]');
    const panel=drawer?.querySelector('[data-cr2-mini-panel]');
    const primary=root?.querySelector('[data-cr2-primary-buy]');
    const form=primary?.closest('form');
    if(!root||!drawer||!panel||!form||drawer.dataset.initialized==='true')return;
    drawer.dataset.initialized='true';
    const $=s=>drawer.querySelector(s);
    const rootUrl=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
    const money=cents=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100);
    let previousFocus=null;
    let priorOverflow='';
    let lastAddedId=null;
    let ongoing=false;
    async function fetchCart(){
      const res=await fetch(rootUrl+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!res.ok)throw Error('Le panier ne peut pas être actualisé.');
      return res.json();
    }
    async function addVariant(id,quantity=1){
      const res=await fetch(rootUrl+'cart/add.js',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items:[{id:Number(id),quantity:Number(quantity)}]})
      });
      const data=await res.json().catch(()=>({}));
      if(!res.ok)throw Error(data.description||data.message||"Impossible d'ajouter cette référence.");
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return data;
    }
    function showError(message){
      const node=$('[data-cr2-mini-error]');
      if(node){node.hidden=false;node.textContent=message;}
    }
    function clearError(){
      const node=$('[data-cr2-mini-error]');
      if(node){node.hidden=true;node.textContent='';}
    }
    function renderCart(cart,variantId){
      const items=cart.items||[];
      const added=items.find(it=>Number(it.id)===Number(variantId))||items[items.length-1];
      const img=$('[data-cr2-mini-img]');
      const name=$('[data-cr2-mini-name]');
      const variant=$('[data-cr2-mini-variant]');
      const unit=$('[data-cr2-mini-item-price]');
      if(added){
        if(img){img.src=added.image||'';img.alt='Sachet '+(added.product_title||'de créatine');img.hidden=!added.image;}
        if(name){
          const title=added.product_title||added.title||'Créatine';
          name.textContent=title.replace(/^OstroVit Créatine Monohydrate(?:\s+300 g)?\s*[—-]\s*/i,'');
        }
        if(variant)variant.textContent=added.variant_title&&added.variant_title!=='Default Title'?added.variant_title:'';
        if(unit)unit.textContent=money(added.final_price)+' l’unité';
      }
      const total=$('[data-cr2-mini-total]'),count=$('[data-cr2-mini-count]');
      if(total)total.textContent=money(cart.total_price);
      if(count)count.textContent='('+cart.item_count+' '+(cart.item_count===1?'article':'articles')+')';
      const ship=$('[data-cr2-mini-freeship]');
      if(ship){
        const onlyCrea=items.length>0&&items.every(it=>/^OST-CREA-/i.test(String(it.sku||'')));
        ship.hidden=!onlyCrea;
        if(onlyCrea){
          const subtotal=Math.max(0,Number(cart.total_price)||0);
          const left=Math.max(0,3000-subtotal);
          const text=ship.querySelector('[data-cr2-mini-freeship-text]');
          const bar=ship.querySelector('[data-cr2-mini-freeship-progress]');
          if(text)text.textContent=left===0?'Livraison offerte en France atteinte !':'Plus que '+money(left)+' pour la livraison offerte en France.';
          if(bar)bar.style.width=Math.max(0,Math.min(100,subtotal/3000*100))+'%';
        }
      }
    }
    async function update(variantId){
      try{const cart=await fetchCart();renderCart(cart,variantId)}catch(e){showError(e?.message||'Impossible de recharger le panier.');}
    }
    function focusables(){
      return [...panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>!el.hidden&&el.getClientRects().length);
    }
    function keydown(event){
      if(event.key==='Escape'){event.preventDefault();close();return;}
      if(event.key!=='Tab')return;
      const list=focusables();if(!list.length){event.preventDefault();panel.focus();return;}
      const first=list[0],last=list[list.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
    function open(){
      if(drawer.hidden){previousFocus=document.activeElement;priorOverflow=document.body.style.overflow;document.body.style.overflow='hidden';drawer.hidden=false;document.addEventListener('keydown',keydown);}
      clearError();
      const close=$('.cr2-mini-x');
      if(close)close.focus();else panel.focus();
    }
    function close(){
      if(drawer.hidden)return;
      drawer.hidden=true;document.body.style.overflow=priorOverflow;document.removeEventListener('keydown',keydown);
      if(previousFocus?.isConnected)previousFocus.focus();
    }
    drawer.querySelectorAll('[data-cr2-mini-close]').forEach(button=>button.addEventListener('click',close));
    form.addEventListener('submit',async event=>{
      if(!window.fetch)return;
      event.preventDefault();
      if(ongoing)return;
      const select=form.querySelector('[name="id"]');
      const quantity=form.querySelector('[name="quantity"]');
      const button=root.querySelector('[data-cr2-primary-buy]');
      const variantId=select?.value,qty=Math.max(1,Number.parseInt(quantity?.value,10)||1);
      if(!variantId){return;}
      if(button?.disabled)return;
      ongoing=true;
      const originalLabel=button?.querySelector('[data-cr2-buy-label]')?.textContent;
      if(button){button.disabled=true;const label=button.querySelector('[data-cr2-buy-label]');if(label)label.textContent='Ajout en cours…';}
      try{
        await addVariant(variantId,qty);
        lastAddedId=variantId;
        open();
        await update(variantId);
      }catch(e){
        const inline=root.querySelector('[data-cr2-stock-message]');
        if(inline){inline.hidden=false;inline.textContent=e?.message||"Impossible d'ajouter ce produit.";}
      }finally{
        ongoing=false;
        if(button){const selected=select?.selectedOptions?.[0];button.disabled=selected ? selected.textContent.includes('indisponible'):false;const label=button.querySelector('[data-cr2-buy-label]');if(label)label.textContent=originalLabel||'Ajouter au panier';}
      }
    });
    document.addEventListener('crearoma:added',async e=>{
      const id=e.detail?.variantId;
      if(!id)return;
      lastAddedId=id;
      open();
      await update(id);
    });
    drawer.querySelectorAll('[data-cr2-mini-upsell]').forEach(button=>{
      button.addEventListener('click',async()=>{
        if(ongoing)return;
        const id=button.dataset.variantId;
        if(!id)return;
        ongoing=true;
        clearError();
        const label=button.textContent;
        button.disabled=true;button.textContent='Ajout…';
        try{
          await addVariant(id,1);
          lastAddedId=id;
          await update(id);
        }catch(e){showError(e?.message||"Cette saveur n'a pas pu être ajoutée.");}
        finally{button.disabled=false;button.textContent=label;ongoing=false;}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
